import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { GriffePage } from './griffe/griffe';


@Component({
  selector: 'page-griffetyp',
  templateUrl: 'griffetyp.html',
})
export class GriffeTypPage {
griffe: any; 
selectedGriffe: any;
griffe_cat: any;
griffe_subcat: any;
griffe_img: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController ) 
  { 
  this.selectedGriffe = this.navParams.get('selectedGriffe');
  this.griffe_subcat = this.navParams.get('griffe_subcat');
  console.log(this.griffe_subcat);
  }
  
    selectGriffe(griffe, griffe_img){
    this.selectedGriffe = griffe;
    this.griffe_img = griffe_img
    this.viewCtrl.dismiss({ griffe: this.selectedGriffe, griffe_img: this.griffe_img, });
}

    closeModal(){
    this.viewCtrl.dismiss({ griffe: this.selectedGriffe, griffe_img: this.griffe_img, });
} 
  

  ionViewDidLoad() {
    console.log('ionViewDidLoad FenstertypPage');
  }
  
    ionViewWillEnter() : void
   {
    this.getGriffeAll();
   }
   
   
  getGriffeAll(){
  this.griffe_cat = 1;
  this.presentLoading();
  this.userService.getGriffeAll(this.griffe_cat, this.griffe_subcat).subscribe((data : any) =>
      {
          this.griffes = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getGriffeAll();
   refresher.complete();
   }

}


// WEBPACK FOOTER //
// ./src/pages/griffetyp/griffetyp.ts